import React from "react";
import { Box, Paper, Typography, useMediaQuery, useTheme } from "@mui/material";
import { FaCoffee } from "react-icons/fa";
import { ICategory } from "../../../../redux/inventory";

const random_colors = ["#C1E9DE", "#FBC1D9", "#E5DADE", "#E5CDEE"]

const getRandomColorFromStringArray = (): string => {
    const randomIndex = Math.floor(Math.random() * random_colors.length);
    return random_colors[randomIndex];
}



export interface IMenuCategoryCardProps {
    data: ICategory,
    isActive: boolean,
    onClick: () => void
}
export const MenuMenuCategoryCard: React.FC<IMenuCategoryCardProps> = ({
    data,
    isActive,
    onClick
}) => {
    const theme = useTheme();
    const isLightMode = theme.palette.mode === "light";
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            display={"flex"}
            sx={{
                minWidth: isMobile ? "140px" : "auto",
                flexShrink: 0
            }}
        >
            <Paper
                elevation={1}
                square={false}
                sx={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    justifyContent: isMobile ? "center" : "space-between",
                    alignItems: isMobile ? "center" : "flex-start",
                    gap: isMobile ? 1 : 4,
                    opacity: isActive ? 1 : 0.7,
                    bgcolor: isLightMode ? "var(--secondary-color)" : "var(--primary-color)",
                    color: isLightMode ? "var(--text-light-color)" : "var(--text-dark-color)",
                    px: isMobile ? 1 : 1.5,
                    paddingY: isMobile ? 1.5 : 2,
                    borderRadius: 1,
                    width: isMobile ? "115px" : "100%",
                    cursor: "pointer",
                    textAlign: isMobile ? "center" : "left"
                }}
                onClick={onClick}
            >
                <Box sx={{ height: isMobile ? 28 : 36, width: isMobile ? 28 : 36 }}>
                    <FaCoffee fontSize={isMobile ? "2rem" : "2.2rem"} />
                </Box>
                <Box>
                    <Typography
                        variant={isMobile ? "body1" : "h4"}
                        fontWeight={"bold"}
                        letterSpacing={-0.5}
                        sx={{
                            fontSize: isMobile ? "0.9rem" : undefined
                        }}
                    >
                        {data.category_name}
                    </Typography>
                    {!isMobile && (
                        <Typography variant="h6" color={"#595959"} fontWeight={"500"}>
                            {/* {data.number_of_items} Items */}
                        </Typography>
                    )}
                </Box>
            </Paper>
        </Box>
    );
};
